/**
 * @module Loading
 */

import {ClientApplication} from '../../client';
import {actionWrapper, ActionSet} from '../helper';
import {ActionSetPayload, Group, MetaAction} from '../types';
import {invalidActionType, throwError, ActionType as ErrorActionType, ErrorAction} from '../Error';
import {Action, ActionType, Payload} from './types';

export type LoadingAction = MetaAction;

export function start(payload?: Payload): LoadingAction {
  return actionWrapper({
    payload,
    group: Group.Loading,
    type: ActionType.START,
  });
}

export function stop(payload?: Payload): LoadingAction {
  return actionWrapper({
    payload,
    group: Group.Loading,
    type: ActionType.STOP,
  });
}

export function validationError<A extends MetaAction>(action: A): undefined | ErrorAction {
  switch (action.type) {
    case ActionType.START:
    case ActionType.STOP:
      // No validation since there should not be a payload
      return undefined;
    default:
      return invalidActionType(action);
  }
}

export class Loading extends ActionSet implements ActionSetPayload<Payload> {
  constructor(app: ClientApplication<any>) {
    super(app, Group.Loading, Group.Loading);
  }

  get payload() {
    return {id: this.id};
  }

  dispatch(action: Action) {
    switch (action) {
      case Action.START:
        this.app.dispatch(start(this.payload));
        break;

      case Action.STOP:
        this.app.dispatch(stop(this.payload));
        break;

      default:
        throwError(
          ErrorActionType.INVALID_ACTION_TYPE,
          actionWrapper({
            group: this.group,
            type: action,
          }),
        );
    }

    return this;
  }
}

export function create(app: ClientApplication<any>) {
  return new Loading(app);
}



// WEBPACK FOOTER //
// ./src/actions/Loading/actions.ts